module.exports = __webpack_public_path__ + "static/media/tmb.50e35298.jpg";